function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "arrow-bi_svg__a",
  d: "M11.001 7.983H1.016c-1.331 0-1.331-1.875 0-1.875h9.985c1.332 0 1.332 1.875 0 1.875zM.337 6.359L7.327.268C8.301-.582 9.66.79 8.684 1.64l-6.99 6.091C.72 8.582-.638 7.21.338 6.36zm.662 4.658h9.985c1.331 0 1.331 1.875 0 1.875H.999c-1.332 0-1.332-1.875 0-1.875zm10.664 1.624l-6.99 6.091c-.975.85-2.334-.523-1.358-1.373l6.99-6.091c.975-.85 2.334.523 1.358 1.373z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(6 2)"
}, React.createElement("mask", {
  id: "arrow-bi_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#arrow-bi_svg__a"
})), React.createElement("use", {
  fill: "#000",
  fillRule: "nonzero",
  xlinkHref: "#arrow-bi_svg__a"
}), React.createElement("g", {
  fill: "#000",
  mask: "url(#arrow-bi_svg__b)"
}, React.createElement("path", {
  d: "M-6-2h24v24H-6z"
})));

var SvgArrowBi = function SvgArrowBi(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/arrow-bi.98c2e971.svg";
export { SvgArrowBi as ReactComponent };